/**
 * Life4Earth V2 — Color Palette
 *
 * Canonical color values used by theme definitions.
 * These are raw hex/rgba values — NOT CSS variable names.
 * Theme files (dark.ts, light.ts) map these into --var tokens.
 */

/* ------------------------------------------------------------------ */
/*  Slate scale (primary neutrals — dark-mode native)                  */
/* ------------------------------------------------------------------ */
export const SLATE = {
  50:  '#f8fafc',
  100: '#f1f5f9',
  200: '#e2e8f0',
  300: '#cbd5e1',
  400: '#94a3b8',
  500: '#64748b',
  600: '#475569',
  700: '#334155',
  800: '#1e293b',
  900: '#0f172a',
  950: '#020617',
} as const;

/* ------------------------------------------------------------------ */
/*  Brand / accent blues                                               */
/* ------------------------------------------------------------------ */
export const BLUE = {
  50:  '#eff6ff',
  100: '#dbeafe',
  200: '#bfdbfe',
  300: '#93c5fd',
  400: '#60a5fa',
  500: '#3b82f6',
  600: '#2563eb',
  700: '#1d4ed8',
  800: '#1e40af',
  900: '#1e3a8a',
} as const;

/* ------------------------------------------------------------------ */
/*  Semantic hues                                                      */
/* ------------------------------------------------------------------ */
export const RED    = { 400: '#f87171', 500: '#ef4444', 600: '#dc2626' } as const;
export const GREEN  = { 400: '#4ade80', 500: '#22c55e', 600: '#16a34a' } as const;
export const AMBER  = { 400: '#fbbf24', 500: '#f59e0b', 600: '#d97706' } as const;
export const PURPLE = { 400: '#c084fc', 500: '#a855f7', 600: '#9333ea' } as const;

/* ------------------------------------------------------------------ */
/*  Pillar colors (hex values for canvas/SVG that can't use CSS vars)  */
/* ------------------------------------------------------------------ */
export const PILLAR_HEX = {
  problems:    RED[500],
  solutions:   GREEN[500],
  enablers:    BLUE[500],
  communities: SLATE[200],
  projects:    PURPLE[500],
} as const;
